import { useState, useEffect, useCallback } from "react";
import api from "../utils/api"; // 🔥 ekledik
import { historyFetchPlan } from "../utils/historyWindow";

function toMinuteArrays(raw) {
  const out = {};
  for (const k in raw) {
    const arr = Array.isArray(raw[k]) ? raw[k] : [];
    out[k] = arr.map((v) => Math.round(Number(v) || 0));
  }
  return out;
}

export function useImpressionsData(channelId, refreshKey = 0) {
  const [rawImpressions, setRawImpressions] = useState(null);

  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const loadImpressions = useCallback(
    async (controller, isRefresh = false) => {
      if (isRefresh) setRefreshing(true);
      else setLoading(true);

      // Without an explicit start the reader falls back to three months.
      const plan = historyFetchPlan(channelId);

      try {
        const res = await api.get(`/i?c=${channelId}&start=${plan.first}`, {
          signal: controller.signal, // 🔥 axios abort support
        });

        setRawImpressions(toMinuteArrays(res.data));
      } catch (err) {
        if (err.name !== "CanceledError") {
          console.error("Impressions fetch error:", err);
        }
        return;
      } finally {
        if (isRefresh) setRefreshing(false);
        else setLoading(false);
      }

      // See useChannelData: the older stretch follows once the page is drawn.
      if (!plan.backfill) return;

      try {
        const res = await api.get(
          `/i?c=${channelId}&start=${plan.backfill.start}&end=${plan.backfill.end}`,
          { signal: controller.signal }
        );
        setRawImpressions((prev) => ({ ...toMinuteArrays(res.data), ...(prev || {}) }));
      } catch (err) {
        if (err.name !== "CanceledError") {
          console.error("Impressions backfill error:", err);
        }
      }
    },
    [channelId]
  );

  // ✅ first load
  useEffect(() => {
    if (!channelId) return;

    const controller = new AbortController();
    loadImpressions(controller, false);

    return () => controller.abort();
  }, [channelId, loadImpressions]);

  // ✅ refresh
  useEffect(() => {
    if (!refreshKey) return;

    const controller = new AbortController();
    loadImpressions(controller, true);

    return () => controller.abort();
  }, [refreshKey, loadImpressions]);

  return { rawImpressions, loading, refreshing };
}
